import { createProxies } from "./proxies";

export interface ClientHostingExports {
  ClientHosting: ClientHostingExportsMethods;
}

export type RenderGlCallback = (idleFrameCount: number) => boolean;
export type Render2dCallback = (idleFrameCount: number) => number;

interface ClientHostingExportsMethods {
  InterceptGL: () => void;
  Create: (hostInfoJson: string) => string;
  Destroy: (id: string) => void;
  SetPixelRatio: (value: number) => void;
  SetSize: (id: string, width: number, height: number) => string;
  GetRenderFrameGlCallback: (id: string) => RenderGlCallback | null;
  GetRenderFrame2dCallback: (id: string) => Render2dCallback | null;
}

export const {
  setup,
  interceptGL,
  create,
  destroy,
  setPixelRatio,
  setSize,
  getRenderFrameGlCallback,
  getRenderFrame2dCallback,
} = createProxies<ClientHostingExportsMethods>([
  "InterceptGL",
  "Create",
  "Destroy",
  "SetPixelRatio",
  "SetSize",
  "GetRenderFrameGlCallback",
  "GetRenderFrame2dCallback",
]);
